// Générateur de CV optimisé pour réduire la taille des fichiers
export const generateOptimizedCvHtml = (cvData, cvStyle, template) => {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString + '-01');
        return date.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' });
    };

    // HTML optimisé et compact
    return `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>CV - ${cvData.personalInfo.firstName} ${cvData.personalInfo.lastName}</title>
<style>
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:Inter,sans-serif;line-height:1.5;color:#333;max-width:800px;margin:0 auto;padding:20px;background:#fff}
.header{background:#2563eb;color:#fff;padding:20px;border-radius:8px;margin-bottom:20px}
.header h1{font-size:24px;margin:0 0 8px 0}
.header p{font-size:14px;margin:0;opacity:0.9}
.contact{margin-top:10px;font-size:12px}
.section{margin-bottom:20px}
.section h2{font-size:16px;font-weight:bold;color:#1f2937;margin-bottom:10px;padding-bottom:5px;border-bottom:1px solid #e5e7eb}
.summary{font-size:13px;line-height:1.4;color:#4b5563}
.exp-item,.edu-item{margin-bottom:15px}
.job-title,.degree{font-size:14px;font-weight:bold;color:#1f2937}
.company,.institution{font-size:12px;color:#6b7280;margin-bottom:3px}
.date{font-size:11px;color:#9ca3af}
.skills{display:flex;flex-wrap:wrap;gap:6px}
.skill{background:#f3f4f6;padding:3px 6px;border-radius:3px;font-size:11px;color:#374151}
</style>
</head>
<body>
<div class="header">
<h1>${cvData.personalInfo.firstName} ${cvData.personalInfo.lastName}</h1>
<p>${cvData.personalInfo.email}</p>
</div>
${cvData.summary ? `<div class="section"><h2>Résumé</h2><p class="summary">${cvData.summary}</p></div>` : ''}
${cvData.experience && cvData.experience.length > 0 ? `<div class="section"><h2>Expérience</h2>${cvData.experience.map(exp => `<div class="exp-item"><div class="job-title">${exp.title || 'Poste'}</div><div class="company">${exp.company || 'Entreprise'}</div><div class="date">${exp.startDate ? formatDate(exp.startDate) : ''} - ${exp.endDate ? formatDate(exp.endDate) : 'Présent'}</div></div>`).join('')}</div>` : ''}
${cvData.education && cvData.education.length > 0 ? `<div class="section"><h2>Formation</h2>${cvData.education.map(edu => `<div class="edu-item"><div class="degree">${edu.degree || 'Diplôme'}</div><div class="institution">${edu.institution || 'Établissement'}</div><div class="date">${edu.startDate ? formatDate(edu.startDate) : ''} - ${edu.endDate ? formatDate(edu.endDate) : 'Présent'}</div></div>`).join('')}</div>` : ''}
${cvData.skills && cvData.skills.length > 0 ? `<div class="section"><h2>Compétences</h2><div class="skills">${cvData.skills.map(skill => {
    console.log('🔍 Compétence dans generateOptimizedCvHtml:', skill, 'Type:', typeof skill);
    let skillName = '';
    if (typeof skill === 'string') {
        skillName = skill;
    } else if (typeof skill === 'object' && skill !== null) {
        console.log('🔍 Propriétés de l\'objet compétence:', Object.keys(skill));
        skillName = skill.name || skill.title || skill.skill || skill.value || Object.values(skill).join(' ') || '[Compétence]';
    } else {
        skillName = String(skill);
    }
    skillName = skillName.replace(/[{}"]/g, '').trim();
    console.log('🔍 Nom de compétence final:', skillName);
    return `<span class="skill">${skillName}</span>`;
}).join('')}</div></div>` : ''}
${cvData.projects && cvData.projects.length > 0 ? `<div class="section"><h2>Projets</h2>${cvData.projects.map(project => {
    console.log('🔍 Projet dans generateOptimizedCvHtml:', project, 'Type:', typeof project);
    let projectName = '';
    if (typeof project === 'string') {
        projectName = project;
    } else if (typeof project === 'object' && project !== null) {
        console.log('🔍 Propriétés de l\'objet projet:', Object.keys(project));
        projectName = project.name || project.title || project.project || project.value || Object.values(project).join(' ') || '[Projet]';
    } else {
        projectName = String(project);
    }
    projectName = projectName.replace(/[{}"]/g, '').trim();
    console.log('🔍 Nom de projet final:', projectName);
    return `<div class="exp-item"><div class="job-title">${projectName}</div></div>`;
}).join('')}</div>` : ''}
</body>
</html>`;
};

// Fonction pour compresser le HTML généré
export const compressHtml = (html) => {
    return html
        .replace(/\s+/g, ' ') // Remplacer les espaces multiples par un seul
        .replace(/>\s+</g, '><') // Supprimer les espaces entre les balises
        .replace(/\s+$/gm, '') // Supprimer les espaces en fin de ligne
        .trim();
};
